module.exports = __webpack_public_path__ + "static/media/between_the_book.93b7d787.gif";